<template>
    <div>
        <div class="page-content">
            <div class="container-fluid" style="margin-top: 2rem;">
                <div v-if="initialized && headerDisplay" class="row heading">
                    <div class="col-sm-6">
        				<h1>{{ topic || breadcrumb[0].name }}</h1>
                    </div>
                    <div class="col-sm-6">
                        <toplevel-toolbar-component
                            :content="topLevelContent"
                            :config="topLevelConfig"
                            :timestamp="localTimestamp"

                            :changeUrl="changeUrl"
                            :changeQuery="changeQuery"
                            :changeSection="changeSection"

                            :addNotification="addNotification"
                            ></toplevel-toolbar-component>
                    </div>
                </div>

                <notifications
                    group="notification"
                    position="top center"
                    classes="vue-notification"
                    :max="2"
                    ></notifications>

                <div v-if="!initialized" style="position: absolute; left: 55%; top: 10%;">
                    <vue-spinner></vue-spinner>
                </div>
                <b-card v-else no-body>
                    <div class="tabs">
                        <div :class="['card-header', sections.length == 1 ? 'hide' : '']">
                            <ul role="tablist" tabindex="0" class="nav nav-tabs card-header-tabs">
                                <li v-for="section in sections"
                                    v-if="isSectionEnabled(topLevelType, section.name)"
                                    :key="section.name + section.link"
                                    :class="['nav-item']"
                                    role="presentation">
                                    <a role="tab" tabindex="-1" v-on:click="changeTab(section)"
                                        :class="['nav-link', section.active ? 'active' : '']">
                                        {{ __(section.label || section.name, ['titleCase']) }}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="tab-content tab-content-shadow">
                            <div role="tabpanel" class="tab-pane card-body show fade active" style="min-height: 2rem">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h2 class="content-header">
                                            {{
                                                _.chain(breadcrumb).last().get('label').value() ||
                                                _.chain(breadcrumb).last().get('name').str(['titleCase']).value()
                                            }}
                                        </h2>
                                        <ul v-if="breadcrumbDisplay" class="breadcrumb">
                                            <template v-for="node in breadcrumb">
                                                <li :key="node.name + node.link" v-if="node.link">
                                                    <a v-on:click="changeBreadcrumbLink(node.link)">{{ node.label || __(node.name, ['titleCase']) }}</a>
                                                </li>
                                                <li :key="node.name + node.link" v-else>{{ node.label || __(node.name, ['titleCase']) }}</li>
                                            </template>
                                        </ul>
                                    </div>
                                    <div class="col-sm-6 text-right">
                                        <content-toolbar-component
                                            v-if="parent"
                                            :content="parent"
                                            :children="content"
                                            :timestamp="localTimestamp"

                                            :changeUrl="changeUrl"
                                            :changeQuery="changeQuery"
                                            :changeSection="changeSection"

                                            componentName="form-component"
                                            :componentConfig="parentConfig"

                                            :updateData="updateParent"
                                            :deleteData="deleteParent"

                                            :addNotification="addNotification"

                                            v-on:content::creating="doNothing"
                                            v-on:content::created="doNothing"
                                            v-on:content::updated="doNothing"
                                            v-on:content::deleted="backToCollection"
                                            ></content-toolbar-component>
                                        <content-toolbar-component
                                            v-else
                                            :content="localContent"
                                            :timestamp="localTimestamp"
                                            :dirty="dirty"
                                            :contentErrors="contentErrors"
                                            :selected="selected"

                                            :changeUrl="changeUrl"
                                            :changeQuery="changeQuery"
                                            :changeSection="changeSection"

                                            :componentName="componentName"
                                            :componentConfig="componentConfig"

                                            :haltFetch="signalHaltFetch"
                                            :createData="modifiedCreateData"
                                            :updateBatch="modifiedUpdateBatch"
                                            :updateData="modifiedUpdateData"
                                            :deleteData="deleteData"

                                            :addNotification="addNotification"
                                            :commitQueue="commitQueue"

                                            v-on:content::creating="loadNewInstance"
                                            v-on:content::created="doNothing"
                                            v-on:content::updated="resetLocalState"
                                            v-on:content::deleted="backToCollection"
                                            v-on:content::selected="updateSelected"
                                            ></content-toolbar-component>
                                    </div>
                                </div>
                                <div class="tabs">
                                    <div :class="['card-header card-header-inner', subSections.length == 1 ? 'hide' : '']">
                                        <ul role="tablist" tabindex="0" class="nav nav-tabs card-header-tabs">
                                            <li v-for="subSection in subSections"
												:key="subSection.name + subSection.link"
                                                role="presentation"
                                                class="nav-item">
                                                <a role="tab" tabindex="-1" v-on:click="changeSubTab(subSection)"
                                                    :class="['nav-link', subSection.active ? 'active' : '']">
                                                    {{ __(subSection.label, ['titleCase']) || __(subSection.name, ['titleCase']) }}</a>
                                            </li>
                                        </ul>

                                    </div>
                                    <div class="tab-content no-border">
                                        <div role="tabpanel" class="tab-pane card-body show fade active">
                                            <content-toolbar-component
                                                v-if="parent"
                                                :content="localContent"
                                                :parent="parent"
                                                :timestamp="localTimestamp"
                                                :dirty="dirty"
                                                :contentErrors="contentErrors"
                                                :selected="selected"

                                                :changeUrl="changeUrl"
                                                :changeQuery="changeQuery"
                                                :changeSection="changeSection"

                                                :componentName="componentName"
                                                :componentConfig="componentConfig"

                                                :haltFetch="signalHaltFetch"
                                                :createData="modifiedCreateData"
                                                :updateBatch="modifiedUpdateBatch"
                                                :updateData="modifiedUpdateData"
                                                :deleteData="deleteData"

                                                :addNotification="addNotification"
                                                :commitQueue="commitQueue"

                                                v-on:content::creating="loadNewInstance"
                                                v-on:content::created="doNothing"
                                                v-on:content::updated="resetLocalState"
                                                v-on:content::deleted="backToCollection"
                                                v-on:content::selected="updateSelected"
                                                ></content-toolbar-component>

                                            <!-- main content -->
                                            <template v-if="initialized">
                                                <component
                                                    v-if="getComponentForType(fulltype)"
                                                    v-bind="getConfigForType(fulltype)"
                                                    :is="getComponentForType(fulltype)"
                                                    :loading="loading"
                                                    :key="resourcePath"

                                                    :getData="getData"
                                                    :createData="modifiedCreateData"
                                                    :updateBatch="modifiedUpdateBatch"
                                                    :updateData="modifiedUpdateData"
                                                    :deleteData="deleteData"
                                                    :replaceData="replaceData"

                                                    :changeUrl="changeUrl"
                                                    :changeQuery="changeQuery"
                                                    :changeSection="changeSection"
                                                    :addNotification="addNotification"
                                                    :haltFetch="signalHaltFetch"
                                                    :commitQueue="commitQueue"

                                                    :query="query"
                                                    :timestamp="timestamp"
                                                    :content="localContent"
                                                    :resourceParams="resourceParams"

                                                    v-on:content::initialized="updateComponent"
                                                    v-on:content::creating="loadNewInstance"
                                                    v-on:content::created="doNothing"
                                                    v-on:content::updated="resetLocalState"
                                                    v-on:content::changed="updateLocalContent"
                                                    v-on:content::deleted="backToCollection"
                                                    v-on:content::selected="updateSelected"
                                                    ></component>
                                                <content-view-component
                                                    v-else
                                                    :type="fulltype"
                                                    :loading="loading"
                                                    :showLoading="currentSection !== previousSection"

                                                    :getData="getData"
                                                    :createData="modifiedCreateData"
                                                    :updateBatch="modifiedUpdateBatch"
                                                    :updateData="modifiedUpdateData"
                                                    :deleteData="deleteData"

                                                    :changeUrl="changeUrlForSubSection"
                                                    :changeQuery="changeQuery"
                                                    :changeSection="changeSection"
                                                    :addNotification="addNotification"
                                                    :commitQueue="commitQueue"
                                                    :pushQueue="pushQueue"

                                                    :selected="selected"
                                                    :resourceParams="resourceParams"
                                                    :section="section"
                                                    :content="localContent"
                                                    :parent="parent"
                                                    :timestamp="timestamp"
                                                    :query="query"
                                                    :contentType="contentType"
                                                    :relationship="relationship"
                                                    :haltFetch="signalHaltFetch"

                                                    v-on:content::initialized="updateComponent"
                                                    v-on:content::creating="loadNewInstance"
                                                    v-on:content::created="doNothing"
                                                    v-on:content::updated="resetLocalState"
                                                    v-on:content::changed="updateLocalContent"
                                                    v-on:content::deleted="backToCollection"
                                                    v-on:content::selected="updateSelected"
                                                    ></content-view-component>
                                            </template>
                                            <!-- end main content -->
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 offset-sm-6 text-right">
                                        <content-toolbar-component
                                            :content="localContent"
                                            :timestamp="localTimestamp"
                                            :dirty="dirty"
                                            :contentErrors="contentErrors"
                                            :selected="selected"

                                            :changeUrl="changeUrl"
                                            :changeQuery="changeQuery"
                                            :changeSection="changeSection"

                                            :componentName="componentName"
                                            :componentConfig="componentConfig"

                                            :haltFetch="signalHaltFetch"
                                            :createData="modifiedCreateData"
                                            :updateBatch="modifiedUpdateBatch"
                                            :updateData="modifiedUpdateData"
                                            :deleteData="deleteData"
                                            :commitQueue="commitQueue"

                                            :updateParent="updateParent"
                                            :addNotification="addNotification"

                                            v-on:content::creating="loadNewInstance"
                                            v-on:content::created="doNothing"
                                            v-on:content::updated="resetLocalState"
                                            v-on:content::deleted="backToCollection"
                                            ></content-toolbar-component>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card>
            </div>
        </div>
        <control-panel-component
            v-if="initialized && openControlPanel"
            :content="localContent"
            :user="user"
            :timestamp="localTimestamp"
            :dirty="dirty"
            :contentErrors="contentErrors"
            :selected="selected"

            :changeUrl="changeUrl"
            :changeQuery="changeQuery"
            :changeSection="changeSection"

            :componentName="componentName"
            :componentConfig="componentConfig"

            :haltFetch="signalHaltFetch"
            :createData="modifiedCreateData"
            :updateBatch="modifiedUpdateBatch"
            :updateData="modifiedUpdateData"
            :deleteData="deleteData"
            :addNotification="addNotification"
            :commitQueue="commitQueue"

            v-on:close="() => selected = []"
            v-on:content::creating="loadNewInstance"
            v-on:content::created="doNothing"
            v-on:content::deleted="backToCollection"
            v-on:content::selected="updateSelected"
            ></control-panel-component>
        <global-file-modal-component
            ></global-file-modal-component>
    </div>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import Vuex from 'vuex';
import V from 'voca';
import { plural, singular } from 'pluralize';

import Notifications from 'vue-notification';
import MoonLoader from 'vue-spinner/src/MoonLoader.vue';
import BaseContentComponent from './BaseContentComponent';
import ContentViewComponent from './ContentViewComponent';
import ControlPanelComponent from './ControlPanelComponent';
import ContentToolbarComponent from './helpers/ContentToolbarComponent';
import ToplevelToolbarComponent from './helpers/ToplevelToolbarComponent';
import GlobalFileModalComponent from './helpers/GlobalFileModalComponent';

export default {
    extends: BaseContentComponent,

    components: {
        ContentViewComponent,
        ControlPanelComponent,
        ContentToolbarComponent,
        ToplevelToolbarComponent,
        GlobalFileModalComponent,
        VueSpinner: MoonLoader,
    },
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/MainPanelComponent.vue